import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { SandAlarmTestSectionData } from './P66.data';
import { FormInput } from 'elements/Inputs/FormInput';
import { StyleDropdown } from '../AsFoundTestTableSection/AsFoundTestSection.styled';
import { StyleInput } from '../AFT_FireTestSection/AsFoundFireTestSection.styled';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const SandAlarmTestSection = (props) => {
    const { selectedTag, changeHandler, formName, formData, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const filterViewData = SandAlarmTestSectionData(selectedTag, formName, formData);
    const formDropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                inputTextAlign={field.inputTextAlign}
                labelWidth={field.labelWidth}
                direction={field.direction}
                readOnly={field.readOnly || isFormReadOnly}
                isDisabled={field.isDisabled}
                marginBottom={field.marginBottom}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                borderBottom={field.borderBottom}
                height={field.height}
                marginTop={field.marginTop}
                borderTop={field.borderTop}
                paddingPlaceholder={field.paddingPlaceholder}
                arrowMarginTop={field.arrowMarginTop}
                fontSize={field.fontSize}
                borderRight={field.borderRight}
                rootMarginRight={field.rootMarginRight}
                noDefaultOption={field.noDefaultOption}
                inputMarginRight={field.inputMarginRight}
                borderLeft={field.borderLeft}
                subMenu={field.subMenu}
            />
        </StyleDropdown>
    )
        : (
            <StyleInput
                formName={formName}
                isDisabled={field.isDisabled}
            >
                <FormInput
                    id={field.key}
                    name={field.key}
                    label={field.label}
                    value={field.value}
                    isCalculated={field.isCalculated}
                    isCalculatedNew={field.isCalculatedNew}
                    direction={field.direction}
                    isRequired={field.isRequired}
                    handleChange={changeHandler}
                    type={field.type}
                    width={field.width}
                    padding={field.padding}
                    labelWidth={field.labelWidth}
                    marginLeft={field.marginLeft}
                    textAlign={field.textAlign}
                    readOnly={field.readOnly || isFormReadOnly}
                    maxLength={field.maxLength}
                    marginRight={field.marginRight}
                    borderRight={field.borderRight}
                    height={field.height}
                    marginBottom={field.marginBottom}
                    borderBottom={field.borderBottom}
                    borderTop={field.borderTop}
                    borderLeft={field.borderLeft}
                    inputMarginRight={field.inputMarginRight}
                    marginTop={field.marginTop}
                    userRole={userRole}
                    isLabelNew={field.isLabelNew}
                    isLabelBold={field.isLabelBold}
                    fontWeight={field.fontWeight}
                    isDisabled={field.isDisabled}
                    hasDPSError={field.hasDPSError}
                    textAlignLabel={field.textAlignLabel}
                    inputMarginLeft={field.inputMarginLeft}
                    fontColor={field.fontColor}
                    isDeleteLabel={field.isDeleteLabel}
                    color={field.color}
                    fontSize={field.fontSize}
                />
            </StyleInput>
        );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                filterViewData.rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            fontSize={field.fontSize}
                                            color={field.color}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : formDropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SandAlarmTestSection);

SandAlarmTestSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string
};
